import { render, staticRenderFns } from "./rcvacc.vue?vue&type=template&id=2a47a8bb&scoped=true&"
import script from "./rcvacc.vue?vue&type=script&lang=js&"
export * from "./rcvacc.vue?vue&type=script&lang=js&"
import style0 from "./rcvacc.vue?vue&type=style&index=0&id=2a47a8bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a47a8bb",
  null
  
)

export default component.exports